
import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Badge,
  Row,
  Col,
  Button,
  DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown, UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import "assets/css/custom.css";
import ClusterService from '../../services/api/Cluster';
import { toast } from 'react-toastify';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from "react-spinners/ScaleLoader";
import moment from 'moment'
import { CLUSTERSTATUS, wsContinuousHitWaitTime } from '../../settings/shared/constants';
import ReactTable from "react-table";
import "react-sweet-progress/lib/style.css";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Scrollbars } from 'react-custom-scrollbars';
import Pagination from "../../assets/js/Pagination";
import { provisionerTypeLogo } from "settings/shared/commonMethod";

class all extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clusterK8sDTOS: [],
      columns: [],
      percent: '70',
      startcluster: false,
      startindex: 0,
      socketLoadFlag: false,
      swidth: window.innerWidth,
      sheight: window.innerHeight,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    this.state.columns = [
      {
        Header: 'Id',
        accessor: 'Id',
        sortable: true,
        show: false
      },
      {
        Header: 'Cluster Name',
        accessor: 'ClusterName',
        maxWidth: 250,
        sortable: true,
      },
      {
        Header: 'Description',
        accessor: 'Description',
        maxWidth: 200,

      },
      {
        Header: 'Status',
        accessor: 'Status',
        maxWidth: 100,
      },
      {
        Header: 'Monthly Usage',
        accessor: 'MonthlyUsage',
        maxWidth: 120,
      },
      {
        Header: 'Cost',
        accessor: 'Cost',
        maxWidth: 100,
      },
      {
        Header: 'Created By',
        accessor: 'Created',
        maxWidth: 100,
      }, {
        Header: 'Last Modified',
        accessor: 'Lastmodified',
        maxWidth: 150,
      },
      {
        Header: 'Actions',
        accessor: 'Actions',
        maxWidth: 135,

      }

    ];

    if (this.state.percent < 30) {
      this.state.status = "success"
    }
    if (this.state.percent >= 30) {
      this.state.status = "active"
    }
    if (this.state.percent >= 70) {
      this.state.status = "error"
    }
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.removeEventListener("ws-message-cluster", this.eventListerForCluster);
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener("ws-message-cluster", this.eventListerForCluster);
    this.GetAllClusters();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener("ws-message-cluster", this.eventListerForCluster);
  }

  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight });
  }
  StartTerminateState(e, flag, index) {
    this.setState({
      actionstate: !flag,
      startindex: e.currentTarget.id
    })
    this.GetAllClusters();
  }

  // Start Cluster
  StartCluster = (id, e) => {
    let cid = e.currentTarget.id
    ClusterService.clusterStart(id).then((response) => {
      if (response.status === 'SUCCESS') {
        this.setState({
          startcluster: false,
          startindex: cid
        })
        this.GetAllClusters();
        // toast.success("Cluster Started Successfully!");

      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  }

  eventListerForCluster = (event) =>{
     if(event !== undefined){
      this.setState({
        socketLoadFlag: true,
      }, () => {
        this.continuestWebsocketHit();
      })
     }
  }

  continuestWebsocketHit = () => {
    setTimeout(() => {
      this.GetAllClusters();
    }, wsContinuousHitWaitTime);
  }


  // Stop Cluster
  StopCluster = (id, e) => {

    let cid = 0;
    try {
      cid = e.currentTarget.id;
    } catch (err) {

    }

    ClusterService.clusterStop(id).then((response) => {
      if (response.status === 'SUCCESS') {
        this.setState({
          startcluster: true,
          startindex: cid
        })
        // toast.success("Cluster Stopped Successfully!");

      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  }
  // Clone Cluster
  CloneCluster = (cloneid) => {
    ClusterService.clusterClone(cloneid).then((response) => {
      if (response.status === 'SUCCESS') {
        this.GetAllClusters()
        // toast.success("Cluster Cloned Successfully!");
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  }

  // Get live status update for current cluster
  GetLiveStatus = (statusId, name) => {
    ClusterService.clusterLiveStatus(statusId).then((response) => {
      if (response.status === 'SUCCESS') {
        // this.GetAllClusters();
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  }

  // Restart Cluster
  RestartCluster = (restartId) => {
    ClusterService.clusterRestart(restartId).then((response) => {
      if (response.status === 'SUCCESS') {
        // toast.success("Cluster Cloned Successfully!");
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  }

  GetAllClusters = () => {
    if (!this.state.socketLoadFlag) {
      this.setState({ loading: true });
    }
    ClusterService.getAllClusters()
      .then((response) => {
        if (response.status === 'SUCCESS') {
          if (response.k8sDTOPage.content !== null) {
            let clusterdetails = response.k8sDTOPage.content;
            this.renderData(clusterdetails);
            this.setState({
              clusterK8sDTOS: clusterdetails,
              loading: false,
              socketLoadFlag: false
            });
          }
        } else {
          this.setState({ socketLoadFlag: false, loading: false });
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
      })
  }

  renderData(clusterdetails) {
    let datas = [];
    let role = localStorage.getItem('role')
    clusterdetails.map((item, index) => {
      datas.push({
        Id: item.id,
        ClusterName: <div className="namedisplay"><span title={item.name} className="overflowStyle"><img className="mr-1" src={ item.provisionerInfoDTO.provisionerType !== undefined ? provisionerTypeLogo(item.provisionerInfoDTO.provisionerType) : ""} alt="noImg"></img> 
        <a href={() => false} className="df-text-primary" onClick={e => this.viewCluster(item.id)} ><b>{item.name}</b></a></span></div>,
        Description: <div className="namedisplay"><span title={item.description} className="overflowStyle">{item.description} </span></div>,
        Status: <div>
          {(item.clusterStatus === CLUSTERSTATUS.PENDING ||
            item.clusterStatus === CLUSTERSTATUS.CREATING ||
            item.clusterStatus === CLUSTERSTATUS.DELETING ||
            item.clusterStatus === CLUSTERSTATUS.STARTING ||
            item.clusterStatus === CLUSTERSTATUS.RESTARTING ||
            item.clusterStatus === CLUSTERSTATUS.PROVISIONING) &&
            <Badge color="" className="badge-dot"><i className="bg-yellow blink" />{item.clusterStatus}</Badge>
          }
          {item.clusterStatus === CLUSTERSTATUS.RUNNING &&
            <Badge color="" className="badge-dot"><i className="bg-success" />{item.clusterStatus}</Badge>
          }
          {(item.clusterStatus === CLUSTERSTATUS.STOPPING || item.clusterStatus === CLUSTERSTATUS.STOPPED) &&
            <Badge color="" className="badge-dot">{item.clusterStatus === "STOPPED" ? <i className="bg-darkgray" /> : <i className="bg-darkgray blink" />}{item.clusterStatus}</Badge>
          }

          {item.clusterStatus === CLUSTERSTATUS.FAILED && <div>
            <span className="actionicon" id={'uncon' + index}>
              <UncontrolledTooltip placement="top" target={'uncon' + index} delay={0}>
                {item.message}
              </UncontrolledTooltip>
              <i className="fas fa-exclamation-triangle" style={{ cursor: "pointer", color: "#ffcc00" }}></i><Badge color="" style={{ marginLeft: 10 }} className="badge-dot">{item.clusterStatus}</Badge>
            </span>
          </div>}

          {item.clusterStatus === CLUSTERSTATUS.ERROR &&
            <Badge color="" className="badge-dot"><i className="bg-red" />{item.clusterStatus}</Badge>
          }
        </div>,
        MonthlyUsage: 0,
        Cost: 0,
        Created: <span title={item.createdBy} className="overflowStyle">{item.createdBy} </span>,
        Lastmodified: <div>{item.updatedDate != null ? moment.utc(item.updatedDate).local().format('MMM DD, YYYY') : ""} <br></br>{item.updatedDate != null ? moment.utc(item.updatedDate).local().format('hh:mm A') : ""}</div>,
        Actions: ((role !== null && role !== undefined && role === 'PLATFORM_ADMIN') || item.platformDefault !== true) && <Row>
          <span className="actionicon" id={'liveStatus' + index} onClick={e => {
            e.preventDefault()
            this.GetLiveStatus(item.id, item.name)
          }}><i className="fab fa-creative-commons-sampling mr-2" style={{ color: '#97c61b', cursor: 'pointer', fontSize: 18 }}><span style={{ paddingLeft: 7 }}>|</span></i>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <UncontrolledTooltip placement="top" target={'liveStatus' + index} delay={0}>
            Live Status
          </UncontrolledTooltip>
          <div className="row" style={(item.clusterStatus === CLUSTERSTATUS.CREATING || item.clusterStatus === CLUSTERSTATUS.STARTING || item.clusterStatus === CLUSTERSTATUS.STOPPING || item.clusterStatus === CLUSTERSTATUS.DELETING || item.clusterStatus === CLUSTERSTATUS.RESTARTING) ? { pointerEvents: "none", opacity: 0.4 } : {}}>
            {/* {((this.state.startcluster === false) && (this.state.startindex === 'action'+index)) */}
            {(item.clusterStatus === CLUSTERSTATUS.RUNNING)
              ?
              <div>
                <span className="actionicon" id={'action' + index} onClick={e => { this.StopCluster_Confirmation(item.id, e, item.name) }}><i className="fas fa-stop-circle mr-2 " style={{ color: 'red' }}></i> &nbsp;</span>
                <UncontrolledTooltip placement="bottom" target={'action' + index} delay={0}>
                  Stop
                </UncontrolledTooltip>
              </div>
              :
              <div style={item.clusterStatus === CLUSTERSTATUS.ERROR ? { pointerEvents: "none", opacity: 0.4 } : {}}>
                <span className="actionicon" id={'action' + index} onClick={e => { this.StartCluster(item.id, e) }}><i className="fas fa-play-circle mr-2" style={{ color: 'green' }}></i> &nbsp;</span>
                <UncontrolledTooltip placement="bottom" target={'action' + index} delay={0}>
                  Start
                </UncontrolledTooltip>
              </div>
            }
            <span style={item.clusterStatus === CLUSTERSTATUS.RUNNING ? {} : { pointerEvents: "none", opacity: 0.4 }} className="actionicon" id={'restart' + index} onClick={e => {
              e.preventDefault()
              this.RestartClusterConfirmation(item.id, item.name)
            }}><i className="fas fa-undo-alt mr-2" style={{ color: '#808080c7', cursor: 'pointer' }}></i> &nbsp;</span>
            <UncontrolledTooltip placement="bottom" target={'restart' + index} delay={0}>
              Restart
            </UncontrolledTooltip>
            <UncontrolledDropdown direction="down">
              <DropdownToggle
                tag="span"
                onClick={e => e.preventDefault()}
                style={{ color: '#007bff', cursor: 'pointer' }}
              >
                <i className="fas fa-ellipsis-v" />
              </DropdownToggle>
              <DropdownMenu
                persist right
                className="dropdown-menu-arrow"
              >
                <DropdownItem
                  onClick={e => {
                    e.preventDefault()
                    this.CloneClusterConfirmation(item.id, item.name)
                  }}
                >
                  <span>
                    <i className="far fa-clone df-text-primary fa-lg mr-3" /> Clone
                  </span>
                </DropdownItem>

                <DropdownItem
                  onClick={e => this.deleteCluster(item.id, item.name)}>
                  <span>
                    <i className="fas fa-trash-alt df-text-danger fa-lg mr-3" /> Delete
                  </span>
                </DropdownItem>
                <DropdownItem
                  onClick={e => this.forceDeleteConfirm(item.id, item.name)}>
                  <span> <i className="fas fa-skull-crossbones df-text-danger fa-lg mr-3"></i>
                    Force Delete
                  </span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </Row>
      })
    });

    this.setState({
      clusterdetails: datas,
    });

  }
  viewCluster = (id) => {
    this.props.history.push({
      pathname: '/cluster/viewcluster/' + id,
      state: { mode: "viewCluster", viewClusterId: id, }
    })
  }
  // Delete Cluster
  deleteCluster = (id, name) => {
    confirmAlert({
      title: "Delete Cluster",
      message: <div><span>
        Are you sure to delete this cluster? -  <b><i>{name}</i></b>
      </span><br />
      </div>,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.confirmDelete(id)
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ]
    });
  }

  // force Delete Cluster
  forceDeleteConfirm = (id, name) => {
    confirmAlert({
      title: <h5><i className="fas fa-skull-crossbones df-text-danger fa-2x mr-3"></i>Force Remove</h5>,
      message: <div><span>
        Are you sure to force remove this cluster? - <b><i>{name}</i></b>
      </span><br />  <br />
        <span className="df-text-danger hintSize font-weight-bold">Hint : </span> <span className="df-text-danger hintSize"> After this, Cluster won’t controlled by DecisionForce!</span>
      </div>,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.forceDeleteById(id)
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ],
    });
  }


  StopCluster_Confirmation = (id, e, name) => {
    confirmAlert({
      title: "Stop Cluster",
      message: <div><span>
        Are you sure to stop this cluster? -  <b><i>{name}</i></b>
      </span><br />
      </div>,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.StopCluster(id, e)
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ]
    });
  }

  CloneClusterConfirmation = (id, name) => {
    confirmAlert({
      title: "Clone Cluster",
      message: <div><span>
        Are you sure to clone this cluster? - <b><i>{name}</i></b>
      </span><br />
      </div>,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.CloneCluster(id)
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ]
    });
  }

  RestartClusterConfirmation = (id, name) => {
    confirmAlert({
      title: "Restart Cluster",
      message: <div><span>
        Are you sure to restart this cluster? - <b><i>{name}</i></b>
      </span><br />
      </div>,
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.RestartCluster(id)
        },
        {
          label: 'No',
          onClick: () => console.log('no')
        }
      ]
    });
  }

  confirmDelete(id) {
    ClusterService.deleteClusterById(id).then((response) => {
      if (response.status === 'SUCCESS') {
        // toast.success("Cluster Deleted Successfully!");
        this.GetAllClusters();
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  }

  forceDeleteById(id) {
    ClusterService.forceRemoveClusterById(id).then((response) => {
      if (response.status === 'SUCCESS') {
        this.GetAllClusters();
      } else {
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    });
  }

  render() {
    return (

      <>
        <PanelHeader
          content={
            <div className="header text-center">
            </div>
          }
        />
        <div className="content">
          <LoadingOverlay
            active={this.state.loading}
            spinner={<ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={"#123abc"}
              loading={this.state.loading}
            />}
          >
            <Row>
              <Col xs={12} md={12}>
                <Card>
                  <CardHeader>
                    <Row className="align-items-center">
                      <div className="col">
                        <CardTitle tag="h5">Clusters</CardTitle>
                      </div>
                      <div className="col text-right">
                        <Link to={{
                          pathname: '/cluster/all',
                          state: { mode: "all" }
                        }}>
                          <span> <i className="fas fa-sync-alt mr-3" onClick={e => this.GetAllClusters()} /></span>
                        </Link>
                        <Link to={{
                          pathname: '/cluster/Create',
                          state: { mode: "newclusters" }
                        }}>
                          <Button
                            color="primary"
                            size="sm"
                          >
                            New Cluster
                          </Button>
                        </Link>
                      </div>
                    </Row>

                  </CardHeader>
                  <CardBody>
                    <div className="carcontent">
                      <Scrollbars autoHeight autoHeightMin={this.state.sheight - 200}>

                        <ReactTable
                          PaginationComponent={Pagination}
                          data={this.state.clusterdetails}
                          columns={this.state.columns}
                          defaultPageSize={10}
                          showPaginationBottom={true}
                          className="-striped -highlight Providerstable"
                        />
                      </Scrollbars>

                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default all;